import styled from 'styled-components'

const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');

export const ConfirmationMessageContainer = styled.div`
    padding-bottom: 24px;
    p {
        font-size: 14px;
        line-height: 23.1px;
        margin: 0px;

        span {
          font-weight: bold;
        }
    }
`

export const Heading4 = styled.h4`
    font-size: 16px;
    font-weight: 600;
    line-height: 26.4px;
    margin: 0px;
    padding-bottom: 8px;

    ${tabletBreakpoints}{
        font-size: 20px;
        line-height: 30px;
    }
`